export default __webpack_public_path__ + "static/media/plant-plain.483b4e2c.svg";